import { Platform, StyleSheet } from 'react-native';
import { neutrals, text } from 'src/theme/colors';

export const styleShared = StyleSheet.create({
  details: {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: 24,
  },
  linkWrapper: {
    width: '100%',
    height: 50,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 4,
    backgroundColor: neutrals.white,
    borderRadius: 32,
    flexDirection: 'row',
    gap: 8,
    paddingLeft: 16,
    borderWidth: 1,
    borderColor: neutrals.coldGrays.fog,
  },
  textWrapper: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
    gap: 8,
    paddingTop: 16,
  },
  title: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 24,
    color: neutrals.neutralGrays.graphite,
  },

  titleWrapper: {
    alignItems: 'center',
    gap: 11,
  },
  ctaUrlShare: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: 16,
    color: text.color.textTertiary,
  },
  gradient: {
    width: 87,
    height: '100%',
    position: 'absolute',
    left: -87,
  },
  tooltip: {
    position: 'absolute',
    top: -40,
    right: 3,
    backgroundColor: neutrals.white,
    borderRadius: 8,
    padding: 8,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 3,
    zIndex: 100,
    alignItems: 'center',
    flexDirection: 'row',
    gap: 4,
  },
  tooltipText: {
    color: neutrals.black,
    fontSize: 12,
    lineHeight: 15.6,
    fontWeight: '700',
    ...Platform.select({
      web: {
        whiteSpace: 'nowrap' as any,
      },
    }),
  },
  tooltipIcon: {
    width: 16,
    height: 16,
  },
  buttonText: {
    color: text.color.interactive,
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 16,
    textAlign: 'center',
  },
  iconCopy: {
    width: 16,
    height: 16,
    color: text.color.interactive,
  },
  textChoice: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 21,
    color: neutrals.neutralGrays.graphite,
  },
});

export const stylesDesktop = StyleSheet.create({
  ...styleShared,
  wrapper: {
    flex: 1,
  },
  mainTitle: {
    fontWeight: 700,
    fontSize: 24,
    lineHeight: 31,
    color: neutrals.neutralGrays.graphite,
  },
  description: {
    fontWeight: 400,
    fontSize: 18,
    lineHeight: 27,
    color: neutrals.neutralGrays.graphite,
  },
  share: { width: 417, gap: 8, alignItems: 'center' },
});

export const stylesMobile = StyleSheet.create({
  ...styleShared,
  wrapper: {
    flex: 1,
  },
  mainTitle: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 26,
    color: neutrals.neutralGrays.graphite,
    textAlign: 'center',
  },
  description: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 20,
    color: neutrals.neutralGrays.graphite,
    textAlign: 'center',
  },
  share: { width: 320, gap: 8, alignItems: 'center' },
});
